export interface UserSessionReportSimpleRequest {
  userId?: string;
  date?: string;
  period?: SessionReportPeriod;
}

export enum SessionReportPeriod {
  PastDay,
  PastWeek,
  PastMonth,
  PastYear
}
